:host(c-dropdown) {
  /**
   * @prop --c-dropdown-background-color: Menu background color
   * @prop --c-dropdown-background-color-hover: Menu item hover background color
   * @prop --c-dropdown-text-color: Menu item text color
   * @prop --c-dropdown-text-color-active: Active menu item text color
   */
  --_c-dropdown-background-color: var(
    --c-dropdown-background-color,
    var(--c-white)
  );
  --_c-dropdown-background-color-hover: var(
    --c-dropdown-background-color-hover,
    var(--c-primary-200)
  );
  --_c-dropdown-text-color: var(--c-dropdown-text-color, var(--c-text-body));
  --_c-dropdown-text-color-active: var(
    --c-dropdown-text-color-active,
    var(--c-primary-600)
  );

  // private
  --_c-dropdown-font-size: 14px;
  --_c-dropdown-height: 42px;

  display: block;
  position: relative;

  mark {
    background-color: transparent;
    box-shadow: 0 2px 0 0 var(--_c-dropdown-text-color-active);
    color: inherit;
  }

  dialog {
    border-radius: 4px;
    background-color: transparent;
    border: none;
    margin: -4px 0 0;
    overflow: visible;
    padding: 4px 0 0;
    position: fixed;

    &::backdrop {
      opacity: 0;
    }

    &[open].mobile {
      background-color: var(--_c-dropdown-background-color);
      width: 100vw;
      max-width: 100vw;
      height: 100vh;
      max-height: 100svh;
      inset: 0;

      .input-top-wrapper {
        padding: 8px;
      }
    }

    .input-bottom-wrapper.active {
      padding-top: 8px;
    }
  }

  .dummy {
    display: none;
  }

  ul {
    background-color: var(--_c-dropdown-background-color);
    box-shadow: 2px 4px 10px #00000029;
    border-radius: 4px;
    list-style: none;
    margin: 0;
    outline: none;
    padding: 0;
    pointer-events: auto;
    visibility: hidden;
    width: 100%;
    height: max-content;
    overflow-y: scroll;

    &.active {
      visibility: visible;
      animation: 0.2s 1 fade-in cubic-bezier(0.25, 0.8, 0.5, 1);

      &.mobile {
        width: 100vw;
        max-width: 100vw;
        height: 100vh;
        max-height: calc(100svh - 60px);
      }
    }
  }

  li {
    align-items: center;
    column-gap: 12px;
    cursor: pointer;
    display: flex;
    flex-wrap: nowrap;
    font-size: var(--_c-dropdown-font-size);
    min-height: var(--_c-dropdown-height);
    outline: none;
    padding-left: 10px;
    padding-right: 10px;
    pointer-events: auto;
    white-space: nowrap;
    width: 100%;
    border-radius: 4px;
    user-select: none;

    span,
    c-option-value {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
    }

    &:hover,
    &:focus,
    &.active {
      background: var(--_c-dropdown-background-color-hover);
      color: var(--_c-dropdown-text-color-active);
      box-shadow: inset 0 0 0 1px var(--_c-dropdown-text-color-active);
    }

    &:not(.disabled, :hover, :focus)[aria-selected="true"] {
      background: var(--_c-dropdown-background-color-hover);
      color: var(--_c-dropdown-text-color-active);
      border-radius: 0;
    }

    &.disabled {
      background-color: rgba(var(--c-tertiary-rgb), 0.05);
      cursor: default;
      filter: grayscale(1) opacity(0.75);
    }
  }

  .visuallyhidden {
    border: 0;
    clip: rect(1px, 1px, 1px, 1px);
    height: 1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }

  @keyframes fade-in {
    from {
      opacity: 0;
      transform: translateY(-8px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
}
